import Http from "./../http";

export default {
  // 推荐食谱
  feedRecommend(params, callback) {
    Http.get(
      "/feed/recommend",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
    // 推荐食谱列表
    feedRecommendList(params, callback) {
      Http.get(
        "/feed/babyKitchen",
        params,
        res => {
          callback(res);
        },
        null,
        "lucky"
      );
    },
  // 食谱列表
  feedList(params, callback) {
    Http.post(
      "/feed/feedList",
      {},
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  // 月龄
  feedAge(params, callback) {
    Http.get(
      "/feed/feedAge",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  //获取星选食材
  ingredient(params, callback) {
    Http.get(
      "/feed/ingredient",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  // 查询标签
  tagByType(params, callback) {
    Http.get(
      "/content/tag/getTagByType",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  // 喂养要点
  feedPoint(params, callback) {
    Http.get(
      "/feed/feedPoint",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  // 食欲儿歌
  feedSong(params, callback) {
    Http.get(
      "/feed/song",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  // 收藏、点赞、浏览
  feedEventAdd(params, callback) {
    Http.post(
      "/feed/eventAdd",
      {},
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  searchFeedRecipes(params, callback) {
    Http.post(
      "/feed/es/searchFeedRecipes/searchFeedRecipes",
      {},
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  // 获取亲子儿歌详情
  getVideoDetail(urlParams, params, callback) {
    Http.post("/parentSongs/findParentSongs", urlParams, params, res => {
      callback(res);
    });
  },
  // 宝妈都在买  / 星选
  feedShop(params, callback) {
    Http.post(
      "/feed/shopping",
      params,
      {},
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  // 详情
  feedFindById(params, callback) {
    Http.get(
      "/feed/findById",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  }, // 详情
  starFood(params, callback) {
    Http.get(
      "/feed/starFood",
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  },
  feedLikeList(params, callback) {
    Http.post(
      "/feed/likeList",
      {},
      params,
      res => {
        callback(res);
      },
      null,
      "lucky"
    );
  }
};
